import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { DailyPluckingAverageAnalysisRegisteredSchema } from "../DailyPluckingAverageAnalysisRegisteredSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import _ from 'lodash';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Box from '@material-ui/core/Box';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import { Card } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const screenCode = 'DAILYPLUCKINGAVERAGEANALYSISREGISTEREDREPORT'

export function DailyPluckingAverageAnalysisRegisteredReport(props) {

    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const componentRef = useRef();
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%'
        },
        paper: {
            width: '100%',
        },
        table: {
            minWidth: 750
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));

    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [gangs, setGang] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        month: "",
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(DailyPluckingAverageAnalysisRegisteredSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const contentRowNames = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26];
    const [totalRow, setTotalRow] = useState([]);
    const [accTotalRow, setAccTotalRow] = useState([]);
    const [fullLeafTotal, setFullLeafTotal] = useState(0);
    const [fullDayCount, setFullDayCount] = useState(0);
    const [fullPluckingAvg, setFullPluckingAvg] = useState(0);
    const [fullNameCount, setFullNameCount] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        month: ""
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
    }, [searchData.operationEntityID])

    useEffect(() => {
        trackPromise(
            getGangByCollectionPointID()
        )
    }, [searchData.collectionPointID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'DAILYPLUCKINGAVERAGEANALYSISREGISTEREDREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    async function getGangByCollectionPointID() {
        const gang = await service.getGangByCollectionPointID(searchData.operationEntityID, searchData.collectionPointID);
        setGang(gang);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyPluckingAverageAnalysisRegisteredSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {
        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetDailyHarvesterPerformancesReport(searchData);
        let newRes = _.cloneDeep(reportData);
        newRes.forEach(x => {
            x.dataList.forEach(y => {
                y.dataList.forEach(z => {
                    if (z.configurationValue < z.totalAmount || z.configurationValue === z.totalAmount) {
                        z.amount = 1;
                    } else {
                        z.amount = 0.5;
                    }
                })
            })
        })

        newRes.forEach(x => {
            x.dataList.forEach(z => {
                z.dataList.forEach(y => {
                    if (parseInt(y.totalAmount) == 1) {
                        y.range = 1;
                    } else if (parseInt(y.totalAmount) == 2) {
                        y.range = 2;
                    } else if (parseInt(y.totalAmount) == 3) {
                        y.range = 3;
                    } else if (parseInt(y.totalAmount) == 4) {
                        y.range = 4;
                    } else if (parseInt(y.totalAmount) == 5) {
                        y.range = 5;
                    } else if (parseInt(y.totalAmount) == 6) {
                        y.range = 6;
                    } else if (parseInt(y.totalAmount) == 7) {
                        y.range = 7;
                    } else if (parseInt(y.totalAmount) == 8) {
                        y.range = 8;
                    } else if (parseInt(y.totalAmount) == 9) {
                        y.range = 9;
                    } else if (parseInt(y.totalAmount) == 10) {
                        y.range = 10;
                    } else if (parseInt(y.totalAmount) == 11) {
                        y.range = 11;
                    } else if (parseInt(y.totalAmount) == 12) {
                        y.range = 12;
                    } else if (parseInt(y.totalAmount) == 13) {
                        y.range = 13;
                    } else if (parseInt(y.totalAmount) == 14) {
                        y.range = 14;
                    } else if (parseInt(y.totalAmount) == 15) {
                        y.range = 15;
                    } else if (parseInt(y.totalAmount) == 16) {
                        y.range = 16;
                    } else if (parseInt(y.totalAmount) == 17) {
                        y.range = 17;
                    } else if (parseInt(y.totalAmount) == 18) {
                        y.range = 18;
                    } else if (parseInt(y.totalAmount) == 19) {
                        y.range = 19;
                    } else if (parseInt(y.totalAmount) == 20) {
                        y.range = 20;
                    } else if (parseInt(y.totalAmount) == 21) {
                        y.range = 21;
                    } else if (parseInt(y.totalAmount) == 22) {
                        y.range = 22;
                    } else if (parseInt(y.totalAmount) == 23) {
                        y.range = 23;
                    } else if (parseInt(y.totalAmount) == 24) {
                        y.range = 24;
                    } else if (parseInt(y.totalAmount) == 25) {
                        y.range = 25;
                    } else {
                        y.range = 26;
                    }
                })
            })
        })


        let total = [];

        newRes.forEach(x => {
            x.dataList.forEach(z => {
                let list = [];
                contentRowNames.map((item) => {
                    list = z.dataList.filter(x => x.range == item)
                    let cTotal = 0;
                    if (list) {
                        list.forEach(x => {
                            cTotal += x.amount;
                        })
                        total.push({
                            name: item,
                            val: cTotal
                        })
                    } else {
                        total.push({
                            name: item,
                            val: 0
                        })
                    }
                })
            });
        })

        newRes.forEach(x => {
            x.dataList.forEach(y => {
                const distinctElements = [...new Set(y.dataList.map((item) => item.registrationNumber))].map((name) => {
                    return y.dataList.find((item) => item.registrationNumber === name);
                })
                y.namecount = distinctElements.length
            })
        })

        let accTotal = []
        newRes.forEach(x => {
            x.dataList.forEach(z => {
                let LeafTotal = 0;
                let nameCount = 0;
                let dayCount = 0;
                let pluckingAvg = 0;
                let id = 0
                contentRowNames.map((item) => {
                    const value = z.dataList.filter(x => x.range == item)

                    let total = 0;
                    value.forEach(x => {
                        total += x.amount;
                        LeafTotal += x.totalAmount;

                    })
                    dayCount += total
                    pluckingAvg = LeafTotal / dayCount
                });
                nameCount += z.namecount;
                accTotal.push({
                    LeafTotal: LeafTotal,
                    dayCount: dayCount,
                    pluckingAvg: pluckingAvg,
                    nameCount: nameCount
                })
            });
        })

        let fullLeafTotal = 0;
        let fullDayCount = 0;
        let fullPluckingAvg = 0;
        let fullNameCount = 0;

        accTotal.forEach(x => {
            fullLeafTotal += x.LeafTotal;
            fullDayCount += x.dayCount;
            fullPluckingAvg += x.pluckingAvg;
            fullNameCount += x.nameCount;
        })

        setFullLeafTotal(fullLeafTotal);
        setFullDayCount(fullDayCount);
        setFullPluckingAvg(fullPluckingAvg);
        setFullNameCount(fullNameCount);
        setTotalRow(total);
        setAccTotalRow(accTotal);
        setReportData(newRes);
        setSelectedSearchData(selectedSearchValues);
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            month: searchData.month
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function dialogBox(data) {
        setdata(data);
        setOpen(true);

    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Daily Plucking Average Analysis Registered Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Estate</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Month *</InputLabel>
                                    <TextField
                                        id="month"
                                        name="month"
                                        type="month"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {reportData.length > 0 ?
                                <div className="form-group row">
                                    <div className="col-md-12 pb-1">
                                        <Container>
                                            <Card style={{ justifycontent: 'center' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table">
                                                            <TableHead>
                                                                <TableRow style={{ border: "2px solid black" }}>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Estate</TableCell>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Division</TableCell>
                                                                    {contentRowNames.map((item) => (
                                                                        (item == 26 ?
                                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>{'>26'}</TableCell>
                                                                            :
                                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>{item}</TableCell>
                                                                        )
                                                                    ))}
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Names on Ch.Roll</TableCell>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>M&W Days Plucking</TableCell>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Leaf(kg)</TableCell>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Plucking Avg</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        let pluckingAvgTotalAll = 0;
                                                                        let LeafTotalAll = 0
                                                                        return (
                                                                            <>
                                                                                {row.dataList.map((column) => {
                                                                                    let LeafTotal = 0;
                                                                                    let nameCount = 0;
                                                                                    let dayCount = 0;
                                                                                    let pluckingAvg = 0;
                                                                                    return (
                                                                                        <>
                                                                                            <TableRow >
                                                                                                <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>{row.operationEntityName}</TableCell>
                                                                                                <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }} >{column.collectionPointName}</TableCell>
                                                                                                {contentRowNames.map((item) => {
                                                                                                    const value = column.dataList.filter(x => x.range == item)
                                                                                                    nameCount += value.length;
                                                                                                    let total = 0;
                                                                                                    value.forEach(x => {
                                                                                                        total += x.amount;
                                                                                                        LeafTotal += x.totalAmount;
                                                                                                    })
                                                                                                    dayCount += total
                                                                                                    pluckingAvg = LeafTotal / dayCount
                                                                                                    pluckingAvgTotalAll += pluckingAvg
                                                                                                    LeafTotalAll += LeafTotal
                                                                                                    return (
                                                                                                        value.length == 0 ?
                                                                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>
                                                                                                                {'-'}
                                                                                                            </TableCell> :
                                                                                                            <>
                                                                                                                <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>
                                                                                                                    <IconButton size="small" style={{ fontWeight: "bold", fontSize: '14px' }} onClick={() => dialogBox(value)} >
                                                                                                                        {total}
                                                                                                                    </IconButton>
                                                                                                                </TableCell>
                                                                                                            </>
                                                                                                    );
                                                                                                })}
                                                                                                <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} >{column.namecount}</TableCell>
                                                                                                <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} >{dayCount}</TableCell>
                                                                                                <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} >{LeafTotal}</TableCell>
                                                                                                <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{pluckingAvg.toFixed(2)}</TableCell>
                                                                                            </TableRow>
                                                                                        </>
                                                                                    );
                                                                                })}
                                                                            </>
                                                                        );
                                                                    })}
                                                                <TableRow style={{ border: "2px solid black", fontWeight: "bold" }}>
                                                                    <TableCell colSpan={2} style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} align='center' >Total</TableCell>
                                                                    {contentRowNames.map((item) => {
                                                                        const value = totalRow.filter(x => x.name == item)
                                                                        let tot = 0;
                                                                        value.forEach(x => {
                                                                            tot += x.val
                                                                        })
                                                                        return (
                                                                            value.length == 0 ?
                                                                                <TableCell style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} align='center'>
                                                                                    {'-'}
                                                                                </TableCell> :
                                                                                <>
                                                                                    <TableCell style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} align='center'>{tot}</TableCell>
                                                                                </>
                                                                        );
                                                                    })}
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{fullNameCount}</TableCell>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{fullDayCount}</TableCell>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{fullLeafTotal}</TableCell>
                                                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{fullPluckingAvg.toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 50]}
                                                        component="div"
                                                        count={reportData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={handleChangePage}
                                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Container>
                                        <Dialog
                                            fullScreen={fullScreen}
                                            maxWidth={500}
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="responsive-dialog-title"
                                        >
                                            <DialogTitle id="responsive-dialog-title">
                                                {"Daily Plucking Average Analysis Registered Report "}
                                            </DialogTitle>
                                            <DialogContent>
                                                <DialogContentText>
                                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                                        <TableContainer>
                                                            <Table >
                                                                <TableHead>
                                                                    <TableRow style={{ border: "2px solid black" }}>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Emp No</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Name</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Estate</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Division</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Field Name</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Date</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Qty</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Full / Half</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {data.map(item => {
                                                                        return (
                                                                            <TableRow style={{ border: "2px solid black" }} key={item}>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{item.registrationNumber}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{item.firstName}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{item.collectionPointName}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{item.operationEntityName}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{item.fieldName}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{(item.cardReadTime).slice(0, 10)}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{item.totalAmount}</TableCell>
                                                                                <TableCell align="center" style={{ border: "2px solid black" }}>{item.amount == 0.5 ? 'Half' : 'Full'}</TableCell>
                                                                            </TableRow >
                                                                        )
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Box>
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button autoFocus onClick={handleClose}>
                                                    OK
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </div> : null
                            }
                        </form>
                        {reportData.length > 0 ?
                            <div className="pt-3">
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Create PDF"
                                    />}
                                    content={() => componentRef.current}
                                    documentTitle={'Daily Plucking Average Analysis Registered Report'}
                                />
                                <div hidden={true}>
                                    <CreatePDF ref={componentRef} reportData={reportData}
                                        contentRowNames={contentRowNames}
                                        selectedSearchValues={selectedSearchValues}
                                        fullLeafTotal={fullLeafTotal}
                                        fullDayCount={fullDayCount}
                                        fullPluckingAvg={fullPluckingAvg}
                                        fullNameCount={fullNameCount}
                                        totalRow={totalRow}
                                    />
                                </div>
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}



